













































import { Component, Vue, Prop } from 'vue-property-decorator';
import AppStore from '@/store/AppStore';

@Component({
  components: {},
})
export default class MainMenu extends Vue {
  public mounted() {}

  public get isMenuVisible() {
    return AppStore.menuVisible;
  }

  public hideMenu() {
    AppStore.HideMenu();
  }

  public swipeHandler(event: any) {
    if (this.isMenuVisible) {
      this.hideMenu();
    }
  }
}
